import axios from "../../../../../axios";

// Get Tickets 
// Harshada Bhavsar - (10/04/2026)
export const ADGetTasks = async (status) => {
  return axios.get(`api/Admin/Tasks/${status}`);
};

export const ADGetClosedTasks = async () => {
  return axios.get("/api/Admin/ClosedTasks");
};


// In-progress Task 
// Harshada Bhavsar - 14/04/2026
export const ADInProgressTask = (data) => {
  return axios.post("/api/Admin/Task/MarkInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Completed Task 
// Harshada Bhavsar - 14/04/2026
export const ADCompletedTask = (data) => {
  return axios.post("/api/Admin/Task/MarkCompleted", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Reopen Task 
// Harshada Bhavsar - 14/04/2026
export const ADReopenTask = (data) => {
  return axios.post("/api/Admin/Task/Reopen", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Closed Task 
// Harshada Bhavsar - 14/04/2026
export const ADClosedTask = (data) => {
  return axios.post("/api/Admin/Task/Close", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Hold Task 
// Harshada Bhavsar - 14/04/2026
export const ADHoldTask = (data) => {
  return axios.post("/api/Admin/Task/Hold", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Resume Task 
// Harshada Bhavsar - 15/04/2026
export const ADResumeTask = (data) => {
  return axios.post("/api/Admin/Task/Resume", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Invalid Task 
// Harshada Bhavsar - 15/04/2026
export const ADInvalidTask = (data) => {
  return axios.post("/api/Admin/Task/MarkInvalid", data, {
    headers: { "Content-Type": "application/json" },
  });
};
